import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06d55f03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "center center-box" }
const _hoisted_5 = { class: "center-components-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tapbar = _resolveComponent("tapbar")!
  const _component_slider = _resolveComponent("slider")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_tapbar, {
        class: "tapbar",
        collapsed: _ctx.collapsed
      }, null, 8, ["collapsed"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_slider, {
        class: "slider-bar",
        userSeletPath: _ctx.path,
        onToggleCollapsed: _ctx.toggleCollapsed
      }, null, 8, ["userSeletPath", "onToggleCollapsed"]),
      _createElementVNode("div", {
        class: _normalizeClass(["right", _ctx.collapsed ? 'right-slide' : ''])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
                  default: _withCtx(({ Component, route }) => [
                    _createVNode(_Transition, { name: "slide" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_KeepAlive, { include: ['rdMaterialCode'] }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                            key: route.fullPath
                          }))
                        ], 1024))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ])
  ]))
}